<template>
	<div id="usuario-cuenta" class="d-flex account-page">
		<div class="container">

			<div class="row">
				<div class="col-xl-10 offset-xl-1 main-box">

					<div class="row">

						<div class="col-12 px-2">
							<h1 class="mb-3 page-title">{{ title }}</h1>
						</div>

						<div class="col-lg-4 px-2 col-menu">
							<div class="white-box">
								
									<div class="box-profile">
										<div class="d-block mt-4 pb-3">
											<span class="fa-stack fa-4x user-icon">
												<i class="fas fa-circle fa-stack-2x"></i>
												<i class="fas fas fa-user fa-stack-1x fa-inverse"></i>
											</span>
											<h5 class="txt-username" v-if="isLogged">Bienvenido <br> {{ getUser.nombre }} {{ getUser.apellidos }}</h5>
											<h5 class="txt-username" v-else>Crea tu cuenta</h5>
										</div>
									</div>

									<!-- <hr /> -->

									<div class="box-menu">

										<!-- <template v-if="false"> -->
											<!-- <p class="item">
												<router-link class="btn-menu" to="/usuario"><i class="fas fa-home"></i> Inicio</router-link>
											</p> -->
											<p class="item">
												<router-link class="btn-menu" to="/usuario/mis-datos"><i class="far fa-edit"></i> Mis datos</router-link>
											</p>
											<p class="item">
												<router-link class="btn-menu" to="/usuario/contrasena"><i class="fas fa-lock"></i> Mi contraseña</router-link>
											</p>
											<!-- <p class="item">
												<router-link class="btn-menu" to="/usuario/saldo"><i class="fa fa-phone"></i> Mis numeros Skycel®</router-link>
											</p> -->
											<p class="item">
												<router-link class="btn-menu" to="/usuario/mis-pedidos"><i class="fa fa-file"></i> Mis pedidos</router-link>
											</p>
											<p class="item">
												<router-link class="btn-menu" to="/usuario/saldo"><i class="fas fa-dot-circle"></i> Mis cuentas Skycel®</router-link>
											</p>
											<!-- 
											<p class="item">
												<router-link class="btn-menu" to="/usuario/historial-pagos"><i class="fas fa-history"></i> Historial de pagos</router-link>
											</p> -->
											<!-- <p class="item">
												<router-link class="btn-menu" to="/usuario/pagar-factura"><i class="fad fa-credit-card-blank"></i> Paga tu factura</router-link>
											</p> -->
											<!-- <p class="item">
												<router-link class="btn-menu" to="/usuario/soporte"><i class="fas fa-question-circle"></i> Soporte</router-link>
											</p> -->
											<p class="item">
												<a class="btn-menu" v-on:click="logout()" style="cursor: pointer;"><i class="fas fa-sign-out-alt"></i> Cerrar sesión</a>
											</p>
										<!-- </template> -->

										<!-- <template v-else> -->
											<!-- <p class="item">
												<router-link class="btn-menu" to="/usuario"><i class="fas fa-home"></i> Crea tu cuenta </router-link>
											</p> -->
											<!-- <p class="item">
												<router-link class="btn-menu" to="/"><i class="fas fa-times"></i> Cancelar</router-link>
											</p> -->
										<!-- </template> -->

									</div>
								
							</div>
						</div>

						<div class="col-lg px-2 col-acc-page">
							<router-view class="white-box p-4"></router-view>
						</div>

					</div>

				</div>
			</div>

		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters(['isLogged', 'getUser'])
	},

	data(){
		return{
			title: 'Mi cuenta'
		}
	},

	methods:{
		...mapActions(['authAsk4LogOut']),
		getUrlName(){
			var urlName = this.$route.path;
			// UPDATE GENERAL
			if(urlName == '/usuario'){ this.title = 'Mi Cuenta' }
			if(urlName == '/usuario/mis-datos'){ this.title = 'Mis datos' }
			if(urlName == '/usuario/contrasena'){ this.title = 'Cambiar contraseña' }
			if(urlName == '/usuario/mis-pedidos'){ this.title = 'Mis pedidos' }
		},

		async logout(){
			let response = await this.authAsk4LogOut()
			if(response)
				this.$router.replace('/')
		},
	},

	beforeMount(){
		this.getUrlName();
	},

	mounted(){
		if(this.$root.logged == false){
			this.$router.push("/");
		}
	},

	watch: {
		$route(to, from) {
			this.getUrlName();
		},
	}
}
</script>
